import { debouncedRef } from '@vueuse/core'
import type { ComputedRef, Ref } from '#imports'
import { computed } from '#imports'
import { get, has, type JsonObject } from 'json-pointer'

export default function useSimpleSearch<Type>(
  items: ComputedRef<Type[]>,
  searchText: Ref<string>,
  searchProps: keyof Type | (keyof Type)[] | string | string[], // unable to type json-pointer paths
): ComputedRef<Type[]> {
  const searchQuery = debouncedRef<string>(searchText, 300, { maxWait: 500 })
  return computed(() => {
    if (!items?.value?.length) {
      return []
    }

    if (!searchQuery.value) return items.value
    const lowercaseQuery: string = searchQuery.value.toLowerCase()
    const parts = lowercaseQuery.split(' ')

    const propsArray = Array.isArray(searchProps) ? searchProps : [searchProps]

    return items.value.filter((item) => {
      return propsArray.some((prop) => {
        let value: Type[keyof Type] | null = null

        if ((prop as string).startsWith('/')) {
          if (has(item as JsonObject, prop as string)) {
            value = get(item as JsonObject, prop as string)
          }
        } else {
          value = item[prop as keyof typeof item]
        }

        if (typeof value !== 'string') {
          console.warn(
            `searchProp needs to reference a string on the item you're searching`,
          )
          console.warn(`found: ${value} for ${JSON.stringify(item)}`)
          return false
        }

        const lowercaseValue = value.toLowerCase()
        const matches = parts.filter((word) => lowercaseValue.includes(word))

        return parts.length === matches.length
      })
    })
  })
}
